import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { LANGUAGE_LABELS, type AppLanguage } from "@/i18n/config";
import { useLanguage } from "@/contexts/LanguageContext";

interface LanguageSwitcherProps {
  variant?: "floating" | "panel" | "menu";
  className?: string;
}

const LANGUAGE_OPTIONS: AppLanguage[] = ["pt-BR", "pt-PT", "en", "es", "it"];

export function LanguageSwitcher({
  variant = "panel",
  className,
}: LanguageSwitcherProps) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className={cn("space-y-2", variant === "menu" ? "px-2 py-1" : undefined, className)}>
      {variant !== "menu" ? (
        <p className="text-xs font-medium uppercase tracking-[0.18em] text-clinic-text-muted">
          {t("Idioma")}
        </p>
      ) : null}
      <Select value={language} onValueChange={(value) => setLanguage(value as AppLanguage)}>
        <SelectTrigger
          aria-label={t("Idioma da interface")}
          className={cn(
            "rounded-xl border-clinic-border bg-clinic-surface text-clinic-text",
            variant === "floating" &&
              "h-12 min-w-[148px] border bg-clinic-surface/90 px-4 shadow-lg backdrop-blur-md",
            variant === "panel" && "h-11 w-full min-w-[148px]",
            variant === "menu" && "h-10 w-full border-none bg-transparent px-2 shadow-none",
          )}
        >
          <SelectValue placeholder={t("Idioma")} />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGE_OPTIONS.map((option) => (
            <SelectItem key={option} value={option}>
              {LANGUAGE_LABELS[option]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
